import { Button } from '@bienenkampf/ui';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Link, Outlet, useNavigate } from '@tanstack/react-router';
import { eventSocket, useGameEvents } from '../hooks/useGameEvents.js';
import { useTRPC } from '../lib/trpc.js';

export function AppShell() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  const navigate = useNavigate();
  const me = useQuery(trpc.auth.me.queryOptions());
  const logout = useMutation(
    trpc.auth.logout.mutationOptions({
      onSuccess: async () => {
        await qc.invalidateQueries();
        eventSocket.reconnect();
        await navigate({ to: '/' });
      },
    }),
  );
  useGameEvents();

  return (
    <div className="mx-auto flex min-h-dvh max-w-5xl flex-col">
      <header className="flex items-center justify-between gap-3 px-4 pt-[max(0.75rem,env(safe-area-inset-top))] pb-3">
        <Link to="/" className="flex items-center gap-2">
          <img src="/icon.svg" alt="" className="size-8" />
          <span className="text-lg font-semibold">Bienenkampf</span>
        </Link>
        <div className="flex items-center gap-2 text-sm text-stone-400">
          {me.data?.account ? (
            <>
              <span className="hidden sm:inline">{me.data.account.email}</span>
              {me.data.account.isAdmin && (
                <Link to="/admin" className="text-amber-400">
                  Admin
                </Link>
              )}
              <Button
                variant="ghost"
                size="sm"
                onClick={() => logout.mutate()}
                loading={logout.isPending}
              >
                Abmelden
              </Button>
            </>
          ) : (
            me.isSuccess && (
              <Link to="/login" className="text-amber-400">
                Anmelden
              </Link>
            )
          )}
        </div>
      </header>
      <main className="flex flex-1 flex-col px-4 pb-[max(1rem,env(safe-area-inset-bottom))]">
        <Outlet />
      </main>
    </div>
  );
}
